import styled from '@emotion/styled'
import colors from '@mathflat/common/style/colors'
import clsx from 'clsx'
import * as React from 'react'
import { useEffect, useRef } from 'react'

import { Icon } from '@/component/atoms/Icon'
import type { StyleProps } from '@/types'

import { DropdownContext } from './context'

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any
  disabled?: boolean
  children?: React.ReactNode
  isChecked?: boolean
  subscription?: boolean
  onClick?: (e: React.MouseEvent, next: () => void) => void
} & StyleProps

// deprecated
const DropdownItem = ({
  value,
  disabled = false,
  subscription = true,
  children,
  className,
  style,
  onClick,
}: Props) => {
  const ref = useRef<HTMLButtonElement>(null)
  const context = React.useContext(DropdownContext)
  const isActive = value === context?.value

  useEffect(() => {
    if (isActive) {
      context?.onSelect(value, children)
    }
  }, [context?.value])

  useEffect(() => {
    if (isActive) {
      context?.onSelect(value, children)
    }
  }, [children])

  return (
    <button
      disabled={disabled}
      className={clsx(isActive && 'active', className, !subscription && 'disabled-like')}
      style={style}
      onClick={(e) => {
        if (onClick) {
          onClick(e, () => {
            context?.onSelect(value, children, true)
          })
          return
        }
        context?.onSelect(value, children, true)
      }}
      ref={ref}
    >
      {children}
      {isActive && <Icon name="check" className="check-icon" size={20} color={colors.gray.$900} />}
    </button>
  )
}

export default styled(DropdownItem)`
  display: flex;
  align-items: center;
  text-align: left;

  .check-icon {
    margin-left: auto;
    display: none;
    flex-shrink: 0;
  }

  &.disabled-like,
  &.disabled-like:hover {
    border-color: ${colors.gray.$400};
    background-color: ${colors.gray.$100};
    color: ${colors.gray.$500};
  }

  &.disabled-like:hover {
    cursor: default;
  }
`
